export const THRESHOLD_TABLE_HEADERS = {
  chNo: { nm: "Chassis Number", key: "chNum", sorting: true },
  model: { nm: "Model Name", key: "mo", sorting: true },
  nm: { nm: "Name", key: "user.fn", sorting: true },
  mob: { nm: "Mobile No.", key: "user.mob", sorting: false },
  cid: { nm: "city", key: "user.cName", sorting: true },
  faults: { nm: "Time of Threshold Crossed", sorting: true, key: "stat.data", popoverCard: true },
};

export const MOTOR_STATUS_HEADERS = {
  chNo: { nm: "Chassis Number", key: "chNum", sorting: true },
  model: { nm: "Model Name", key: "mo", sorting: true },
  nm: { nm: "Name", key: "user.fn", sorting: true },
  mob: { nm: "Mobile No.", key: "user.mob", sorting: false },
  cid: { nm: "City", key: "user.cName", sorting: true },
  faults: { nm: "Faults", sorting: true, key: "stat.data", popoverCard: true },
};

export const CHARGING_CYCLE_HEADERS = {
  chNo: { nm: "Chassis Number", key: "chNum", sorting: true },
  model: { nm: "Model Name", key: "mo", sorting: true },
  nm: { nm: "Name", key: "user.fn", sorting: true },
  mob: { nm: "Mobile No.", key: "user.mob", sorting: false },
  cid: { nm: "city", key: "user.cName", sorting: true },
  thresholdCrossed: { nm: "Cycle Completed", sorting: true, key: "stat.data", showPerc: true },
}

export const BATTERY_HEALTH_HEADERS = {
  chNo: { nm: "Chassis Number", key: "chNum", sorting: true },
  model: { nm: "Model Name", key: "mo", sorting: true },
  nm: { nm: "Name", key: "user.fn", sorting: true },
  mob: { nm: "Mobile No.", key: "user.mob", sorting: false },
  cid: { nm: "city", key: "user.cName", sorting: true },
  thresholdCrossed: { nm: "Battey Health", sorting: true, key: "stat.data", showPerc: true },
}

export const SHOW_VEHICLE_HEADERS = {
  regNo: { nm: "Vehicle Number", key: "reg" },
  chNo: { nm: "Chassis Number", key: "chNum" },
  model: { nm: "Vehicle Model", key: "mo", filterTyp: 'select' },
  clrNm: { nm: "Vehicle Color", key: "clrNm", filterTyp: 'select' },
  btrId: { nm: "Battery UID", key: "bId" },
  imei: { nm: "Ajjas IMEI", key: "imei" },
}

export const SHOW_BATTERY_HEADERS = {
  bId: { nm: "Battery UID", key: "bId" },
  ampHrs: { nm: "Ampere Hours", key: "ampHrs", filterTyp: 'select' },
  vltg: { nm: "Voltage", key: "vltg", filterTyp: 'select' },
  manf: { nm: "Manufacturer", key: "manf", filterTyp: 'select' },
  cTyp: { nm: "Connecter Type", key: "cTyp" },
}
export const CLIENT_DRIVERS_HEADERS = {
  dNm: { nm: "Driver Name", key: "dNm", sorting: false, navigate: true },
  drLicence: { nm: "Driving Licence", key: "dl", sorting: false },
  idx: { nm: "Driver ID", key: "idx", sorting: false, navigate: true },
  vid: { nm: "Vehicle Assigned", key: "vreg", sorting: false },
  mob: { nm: "Contact Number", key: "mob", sorting: false },
  amt: { nm: "Amt O/S", key: "outsdAmt", sorting: false },
};
export const VEHICLES_PAYMENT_HEADERS = {
  date: { nm: "Date", key: "ts", sorting: true },
  amtReceived: { nm: "Amount Received", key: "amt", sorting: true },
  paymentMethod: { nm: "Payment Method", key: "pmtMode", sorting: false, filterTyp: 'select' },
  refNo: { nm: "Reference Number", key: "refNo", sorting: true },
  drId: { nm: "Driver Name", key: "drId", sorting: true },
  ss: { nm: "Screenshot", key: "ssUrl", sorting: false, filterTyp: "none" },
  delete: { nm: "", sorting: false, key: "idx", delete: true, filterTyp: "none" },
}

export const ASSIGN_VEHICLES_HEADERS = {
  vehNo: { nm: "Vehicle Number", key: "reg", sorting: true, link: true },
  vehModel: { nm: "V. Model", key: "mo", sorting: false, filterTyp: 'select' },
  vehColor: { nm: "V. Colour", key: "clrNm", sorting: false, filterTyp: 'select' },
  batteryUid: { nm: "Battery UID", key: "bId", sorting: true },
}

export const EV_STAT_HEADERS = {
  101: {headers: THRESHOLD_TABLE_HEADERS},
  102: {headers: MOTOR_STATUS_HEADERS},
  201: {headers: []},
  301: {headers: THRESHOLD_TABLE_HEADERS},
  302: {headers: THRESHOLD_TABLE_HEADERS},
  303: {headers: CHARGING_CYCLE_HEADERS},
  401: {headers: []},
}

export const VIEW_VEHICLES_HEADERS = {
  regNo: { nm: "Vehicle Number", key: "reg", sorting: false, navigate: true },
  imei: { nm: "Ajjas IMEI", key: "imei", sorting: true, showSelect: true },
  mo: { nm: "V. Model", key: "mo", sorting: true, showSelect: true },
  color: { nm: "V. Colour", key: "clrNm", sorting: true, showSelect: true },
  bid: { nm: "Battery UID", key: "bId", sorting: true },
  driver: { nm: "Driver", sorting: true, key: "dNm" },
};

export const LIVE_TRACKING_HEADERS = {
  mapIcon: { nm: "Location", key: "mapIcon", hideSearch: true },
  regNo: { nm: "Registration Number", key: "reg", sorting: false, navigate: true },
  mo: { nm: "Model Name", key: "mo", sorting: true },
  lastSeenTs: { nm: "Last Seen", key: "ts", sorting: true },
  ignition: { nm: "Ignition", key: "ignition", sorting: true },
  speed: { nm: "Speed", label: "Current Speed", key: "spd", sorting: true, showSelect: true },
  status: { nm: "Status", key: "status" },
  heartbeat: { nm: "Battery", key: "heartbeat" },
};

export const LIVE_TRACKING_HEADERS_FOR_B2B = {
  mapIcon: { nm: "Location", key: "mapIcon", hideSearch: true },
  imei: { nm: "Device Imei", key: "dev.imei", sorting: false, navigate: true },
  regNo: { nm: "Registration Number", key: "reg", sorting: false },
  dlrId: { nm: "Dealer", key: "dlrId", sorting: false, navigate: true },
  lastSeenTs: { nm: "Last Seen", key: "ts", sorting: true },
  ignition: { nm: "Ignition", key: "ignition", sorting: true },
  speed: { nm: "Speed", label: "Current Speed", key: "spd", sorting: true, showSelect: true },
  status: { nm: "Status", key: "status" },
  heartbeat: { nm: "Battery", key: "heartbeat" },
};

export const VIEW_GEOFENCES_HEADERS = {
  title: { nm: "Geofence Name", key: "title", sorting: true, navigate: true },
  region: { nm: "Geofence Area", key: "region", sorting: true },
  edit: { nm: "", key: "edit", filterTyp: "none", edit: true, delete: true },
};

export const VIEW_UPLOADED_VEHS = {
  srNo: { nm: "Sr No.", key: "srNo"},
  vehNo: { nm: "Vehicle Number", key: "vehNo"},
  chasisNo: { nm: "Chassis Number", key: "chasisNo"},
};

export const TRANSACTION_TABLE_HEADERS = {
  qty: { nm: "Quantity", key: "qty", sorting: true },
  ts: { nm: "Date", key: "ts", sorting: true },
  actTyp: { nm: "Unique ID", key: "actTyp" },
  remQty: { nm: "Closing Quantity", key: "remQty", sorting: true },
};

export const DEALER_TABLE_HEADERS = {
  dealershipName: { nm: "Dealership Name", key: "nm", sorting: true, navigate: true },
  oem: { nm: "Brands", key: "oem", sorting: true },
  city: { nm: "City", key: "cNm", sorting: true },
  inStock: { nm: "Not mapped", key: "stock", sorting: true },
  installed: { nm: "Mapped", key: "installed", sorting: true },
  totalDevices: { nm: "Total Devices", key: "totalDevices", sorting: true },
};

export const OEM_TABLE_HEADERS = {
  oemName: { nm: "OEM Name", key: "oemNm", sorting: true, navigate: true },
  numberOfDealerships: { nm: "Number of Dealerships", key: "nod", sorting: true },
  inStock: { nm: "Not mapped", key: "stock", sorting: true },
  installed: { nm: "Mapped", key: "installed", sorting: true },
  totalDevices: { nm: "Total Devices", key: "totalDevices", sorting: true },
}

export const DEVICE_IN_STOCK_HEADERS = {
  imei: { nm: "Device IMEI", key: "imei", sorting: true },
  orderId : { nm: "Shipment ID", key: "orderId" },
  deliveryDate: { nm: "Delivery Date", key: "deliveredAt", sorting: true },
  status: { nm: "Status", key: "status", sorting: true },
  pingTest: { nm: "Ping Test Status", key: "pingTest", sorting: true },
};

export const DEVICE_INSTALLED = {
  imei: { nm: "Device IMEI", key: "imei", sorting: true },
  orderId : { nm: "Shipment ID", key: "orderId" },
  deliveryDate: { nm: "Delivery Date", key: "deliveredAt", sorting: true },
  vehicle: { nm: "Vehicle(Chassis Number)", key: "chNum", sorting: true },
  dm: { nm: "Date of Mapping", key: "dm", sorting: true },
  pingTest: { nm: "Ping Test Status", key: "pingTest", sorting: true },
};

export const ALL_DEVICES_HEADERS = {
  imei: { nm: "Device IMEI", key: "imei", sorting: true },
  orderId : { nm: "Shipment ID", key: "orderId" },
  deliveryDate: { nm: "Delivery Date", key: "deliveredAt", sorting: true },
  status: { nm: "Status", key: "status", sorting: true },
  pingTest: { nm: "Ping Test Status", key: "pingTest", sorting: true },
  vehicle: { nm: "Vehicle(Chassis Number)", key: "chNum", sorting: true },
  dm: { nm: "Date of Mapping", key: "dm", sorting: true },
};

export const SHOW_ORDER_HEADERS = {
  // dnm: { nm: "Dealer Name", key: "dnm", sorting: true },
  orderTs: { nm: "Order Date", key: "cdt", sorting: true },
  devcnt: { nm: "Quantity", key: "devcnt", sorting: true },
  orderId: { nm: "Order ID", key: "orderId" },
  // transc: { nm: "Amount", key: "transc", sorting: true },
  // vnm: { nm: "Vendor", key: "vnm", sorting: true },
  currentState: { nm: "Status", key: "currentState"},
};

export const SHOW_SHIPMENT_HEADERS = {
  dnm: { nm: "Dealer Name", key: "dnm", sorting: true },
  orderTs: { nm: "Shipment Request Date", key: "cdt", sorting: true },
  devcnt: { nm: "Quantity", key: "devcnt", sorting: true },
  orderId: { nm: "Shipment ID", key: "orderId" },
  // transc: { nm: "Amount", key: "transc", sorting: true },
  // vnm: { nm: "Vendor", key: "vnm", sorting: true },
  currentState: { nm: "Status", key: "currentState" },
};

export const SHOW_FILTERED_ORDER_HEADERS = {
  orderTs: { nm: "Order Date", key: "cdt", sorting: true },
  devcnt: { nm: "Quantity", key: "devcnt", sorting: true },
  orderId: { nm: "Order ID", key: "orderId" },
  currentState: { nm: "Status", key: "currentState", sorting: true },
};

export const SHOW_DEALER_DEVICES_HEADERS = {
  imei: { nm: "Device IMEI", key: "imei", sorting: true },
  chNum: { nm: "Vehicle (Chassis Number)", key: "chNum", sorting: true },
  pingTest: { nm: "Ping Test Status", key: "pingTest", sorting: true },
};

export const VEHICLE_STATISTICS_HEADERS = {
  imei: { nm: "Devie IMEI", key: "imei" },
  vehicleNumber: { nm: "Registration Number", key: "reg" },
  vehicleName: { nm: "Model Name", key: "mo", sorting: true },
  distance: { nm: "Distance Travelled", key: "dst", sorting: true },
  duration: { nm: "Duration", key: "dur", sorting: true },
  topSpeed: { nm: "Top Speed", key: "tps", sorting: true },
};

export const ALERT_VEHICLE_TABLE_HEADERS = {
  vehicleName: { nm: "Vehicle Name", key: "mo", sorting: true },
  registrationNumber: { nm: "Registration Number", key: "reg" },
  device: { nm: "Device type", key: "hwtyp", sorting: true },
}

export const ROUTE_STATS_HEADERS = {
  srNo: { nm: "Sr No", key: "count" },
  startGf: { nm: "Start", key: "start.tid" },
  start: { nm: "Started At", key: "start.ts" },
  endGf: { nm: "End", key: "end.tid" },
  end: { nm: "Ended At", key: "end.ts" },
  distance: { nm: "Distance", key: "dst" },
}

export const VEHICLE_ACTIVITY_HEADERS = {
  registrationNumber: { nm: "Registration Number", key: "reg" },
  chassisNumber: { nm: "Chassis Number", key: "chNum" },
  distance: { nm: "Distance", key: "dst", sorting: true },
}

export const OPERATIONS_HISTORY_HEADERS = {
  oprNm: { nm: "Operation Name", key: "oprNm", showSearch: true },
  opr: { nm: "Operation", key: "oprType", showSearch: true },
  dateTime: { nm: "Date & Time", key: "dateTime", showSearch: true },
  vehs: { nm: "Vehicles", key: "vehsCnt", showSearch: true },
  viewSumry: { nm: "View Summary", key: "viewSumry", showSearch: false },
}

export const OPERATION_SUMMARY_HEADERS = {
  srNo: { nm: "Sr No", key: "srNo", showSearch: false },
  vehicles: { nm: "Vehicles", key: "reg", showSearch: true },
  status: { nm: "Status", key: "status", showSearch: true },
  dateTime: { nm: "Date & Time", key: "ts", showSearch: true },
}

export const SUB_USERS_HEADERS = {
  unm: { nm: "User Name", key: "nm", sorting: true },
  mob: { nm: "Mobile Number", key: "mob", sorting: true },
  eml: { nm: "Email Address", key: "eml", sorting: true },
  vehCnt: { nm: "Vehicles", key: "vehCnt", sorting: true },
  isa: { nm: "Status", key: "isa", sorting: false },
  options: { nm: "Options" },
}

export const SUB_USER_VEHICLE_HEADERS = {
  regNo: { nm: "Registration Number", key: "reg", sorting: false, navigate: true },
  mo: { nm: "Model Name", key: "mo", sorting: true },
  ignition: { nm: "Ignition", key: "ignition", sorting: true },
  spd: { nm: "Current Speed", key: "spd", sorting: true, showSelect: true },
  status: { nm: "Status", key: "status" },
};

export const SUBUSER_ASSIGN_VEHICLE_HEADERS = {
  regNo: { nm: "Vehicle Number", key: "reg" },
  model: { nm: "Vehicle Name", key: "mo" },
  color: { nm: "Vehicle Color", key: "color" },
  imei: { nm: "Ajjas IMEI", key: "imei" },
}

export const ROUTES_SUMMARY_HEADERS = {
  regNo: { nm: "Registration No.", key: "regNo" },
  routeCount: { nm: "Routes Travelled", key: "routeCount" },
  tripCount: { nm: "Trips", key: "tripCount" },
  totalExpectedDist: { nm: "Expected Route Dist.", key: "totalExpectedDist" },
  totalActualDist: { nm: "Actual Route Dist.", key: "totalActualDist" },
  totalDeviatedDist: { nm: "Deviated Dist.", key: "totalDeviatedDist" },
  totalTravelledDist: { nm: "Total Dist.", key: "totalTravelledDist" },
  totalTravelledDur: { nm: "Duration", key: "totalTravelledDur" },
}

export const SUBSCTIPION_DEVS_HEADERS = {
  dlr: { nm: "Dealership", key: "dlr", showSearch: true },
  reg: { nm: "Registration Number", key: "reg", showSearch: true },
  imei: { nm: "Device IMEI", key: "imei", showSearch: true },
  chNum: { nm: "Chassis no.", key: "chNum", showSearch: true },
  expiring: { nm: "Expiring In", key: "expiring_in", showSearch: false },
  sed: { nm: "Expiring Date", key: "sed", showSearch: false },
}

export const RENEWAL_HISTORY_HEADERS = {
  reqId: { nm: "Request ID", key: "reqId", showSearch: true },
  reqDate: { nm: "Request Date", key: "reqDate", showSearch: true },
  updatedAt: { nm: "Last Updated", key: "updatedAt", showSearch: false },
  devices: { nm: "Devices", key: "devices", showSearch: false },
  status: { nm: "Status", key: "status", showSearch: true },
}